import { PlanManagedBookingRow } from "@/FlexPlan/Pages/ServiceBookings/ManageServiceBookings/Types";

export const calculateRemainingTotal = (rows: PlanManagedBookingRow[]): number => rows.reduce((sum, row) => sum + Number(row.remaining ?? 0), 0);
export const calculateSpentTotal = (rows: PlanManagedBookingRow[]): number => rows.reduce((sum, row) => sum + Number(row.spent ?? 0), 0);
export const calculateAllocatedTotal = (rows: PlanManagedBookingRow[]): number => rows.reduce((sum, row) => sum + (row.quantity ?? 0) * (row.price ?? 0), 0);
